module.exports = __webpack_public_path__ + "assets/img/support_btn.35e9a759.png";